import Axios from "axios";
import config from "../app.config";

export var emailService;
export default emailService = {
    getMailFolders,
    replyMail,
    createMail,
    getMailInFolder,
    getMailDetail,
    getListMailBox,
    getMailReceive,
    updateMailReceived,
    updateIsReadMailReceived,
    getStatisticMailReceiveState,
    getReceiveMailDetail,
    getListThread,
    downloadAttachment,
    updateMailReceivedDetail,
    getMailSent,
    getListMailBoxSend,
    getListCC,
    getListTo,
    refetchMailReceive,
    setUserReadOnly,
    getSelectedMailPreviewMode,
    getDataExportCSV,
    setMailUserName,
    deleteMailReceive,
}

async function getMailFolders(account){
    return await Axios.post(`${config.LOCAL_API_URL}/folders`, account)
        .then(response => {
            if(response.status == 200 && response.data){
                return Promise.resolve(response);
            }
            else{
                return Promise.reject(response);
            }
        })
        .catch(error => {
            return Promise.reject(error);
        })
}
async function replyMail(mailData){
    return await Axios.post(`${config.LOCAL_API_URL}/replyMail/${mailData.mail_id}`, mailData)
        .then(response =>{
            if(response.data.status && response.data){
                return Promise.resolve(response.data);
            }
            else{
                return Promise.resolve(response.data);
            }
        })
        .catch(error =>{
            return Promise.reject(error);
        })
}
async function createMail(mailData){
    return await Axios.post(`${config.LOCAL_API_URL}/createMail`, mailData)
        .then(response =>{
            if(response.data.status && response.data){
                return Promise.resolve(response.data);
            }
            else{
                return Promise.resolve(response.data);
            }
        })
        .catch(error =>{
            return Promise.reject(error);
        })
}

async function getMailInFolder(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/folder/` + data.folder + '/mails', {params: data.query})
        .then(response => {
            if(response.data && response.status == 200) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
async function getMailDetail(data){
    return await Axios.get(`${config.LOCAL_API_URL}/` + data.email + '/' + data.folder + '/mail', {params: data.query})
    .then(response =>{
        if(response.data && response.status == 200){
            return Promise.resolve(response.data);
        }else{
            return Promise.reject(response);
        }
    })
    .catch(error =>{
        return Promise.reject(error);
    })
}

async function getListMailBox(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getListMailBox`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
async function getListMailBoxSend (data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getListMailBoxSend`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
async function getMailReceive(data) {
    let mailBox = data.mailBox
    let queries = data.queries
    return await Axios.get(`${config.LOCAL_API_URL}/getMailReceive/${mailBox}`, {params: queries})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
} 

async function getReceiveMailDetail(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getReceiveMailDetail/${data.email}/${data.inquiry_id}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
} 

async function getListThread(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getThread/${data.email}`, {params:{inquiry_id: data.inquiry_id}})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
} 

async function downloadAttachment(data) {

    return await Axios.get(`${config.LOCAL_API_URL}/downloadAttachment`, {params: {id: data.id, fileName: data.fileName}})
        .then(response => {
        return Promise.resolve(response.data);
        })
        .catch(error => {
        error = error.response;
        const message = (error && error.data && error.data.message) || error.statusText;
        return Promise.reject(message);
        });
}
async function updateMailReceived(data) {
    return await Axios.post(`${config.LOCAL_API_URL}/updateMailReceived`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
async function updateIsReadMailReceived(data) {
    return await Axios.post(`${config.LOCAL_API_URL}/updateIsReadMailReceived`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
async function updateMailReceivedDetail(data) {
    return await Axios.post(`${config.LOCAL_API_URL}/updateMailReceivedDetail/${data.id}`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
async function getStatisticMailReceiveState(){
    return await Axios.get(`${config.LOCAL_API_URL}/getStatisticMailReceiveState`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        })
        .catch(error =>{
            return Promise.reject(error);
        })
}
async function getMailSent(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getMailSent/${data.id}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function getListCC(data) {
  return await Axios.get(`${config.LOCAL_API_URL}/getListCC/${data}`)
      .then(response => {
          if(response.data) {
              return Promise.resolve(response.data);
          } else {
              return Promise.reject(response);
          }
      }).catch(error =>{
          return Promise.reject(error);
      })
}

async function getListTo(data) {
  return await Axios.get(`${config.LOCAL_API_URL}/getListTo/${data}`)
      .then(response => {
          if(response.data) {
              return Promise.resolve(response.data);
          } else {
              return Promise.reject(response);
          }
      }).catch(error =>{
          return Promise.reject(error);
      })
}

async function refetchMailReceive(data) {
  let mailBox = data.mailBox
  let queries = data.queries
  return await Axios.get(`${config.LOCAL_API_URL}/refetchMailReceive/${mailBox}`, {params: queries})
    .then(response => {
        if(response.data) {
            return Promise.resolve(response.data);
        } else {
            return Promise.reject(response);
        }
    }).catch(error =>{
        return Promise.reject(error);
    })
  }


async function setUserReadOnly(data) 
{
    let mailBox = data
    return await Axios.get(`${config.LOCAL_API_URL}/setUserReadOnly/${mailBox}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
  }

  async function getSelectedMailPreviewMode(data) {
    let mailBox = data.mailBox;
    return await Axios.get(`${config.LOCAL_API_URL}/getSelectedMailPreviewMode/${mailBox}`, {params: data})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function getDataExportCSV(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getDataExportCSV`,{params : data})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function setMailUserName(data) {
    return await Axios.post(`${config.LOCAL_API_URL}/setMailUserName`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function deleteMailReceive(data) {
    let mailBox = data['mailBox']
    return await Axios.delete(`${config.LOCAL_API_URL}/MailReceive/${mailBox}`, {data: data})
        .then(response => {
            return Promise.resolve(response.data);
        })
        .catch(error => {
            error = error.response;
            const message = (error && error.data && error.data.message) || error.statusText;
            return Promise.reject(message);
        });
}